import React from 'react'
import styled, { css } from 'styled-components';

const Card = styled.div`
  background: linear-gradient(rgba(251, 251, 251,1),rgba(253, 253, 253,1));
  padding: 20px;
  margin: 0px;
  border: 1px solid #eee;
  & a {
    color: #333;
  }
`;

export default Card;



// WEBPACK FOOTER //
// ./src/components/Shared/Card.js